import type { Router } from 'vue-router';
import { STALE_BUNDLE_RELOAD_AT_KEY } from '@/constants';

const RELOAD_COOLDOWN_MS = 60 * 1000;

const DYNAMIC_IMPORT_ERROR_PATTERN =
  /dynamically imported module|Importing a module script failed|error loading dynamically imported module/i;

const reloadForFreshCode = (reason: string) => {
  const lastReloadAt = Number(globalThis.sessionStorage?.getItem(STALE_BUNDLE_RELOAD_AT_KEY) ?? 0);
  if (Date.now() - lastReloadAt < RELOAD_COOLDOWN_MS) {
    console.warn(`[stale-bundle] ${reason}, but a reload already happened within the cooldown — staying put`);
    return;
  }

  console.warn(`[stale-bundle] ${reason} — reloading to pick up the current build`);
  globalThis.sessionStorage?.setItem(STALE_BUNDLE_RELOAD_AT_KEY, String(Date.now()));
  globalThis.location.reload();
};

/**
 * A deploy replaces the hashed files under `/assets/`, and the express layer in
 * `server.cjs` has no SPA fallback, so a tab still holding the previous
 * index.html gets a 404 on its next lazy route import and dies on a blank
 * screen. Unattended kiosk displays never recover from that on their own.
 * Reloading fetches the current index.html and the asset hashes that go with it.
 */
export const setupStaleBundleRecovery = (router: Router) => {
  globalThis.addEventListener('vite:preloadError', (event) => {
    // Vite rethrows the error unless the event is cancelled.
    event.preventDefault();
    reloadForFreshCode('a chunk preload failed');
  });

  router.onError((error) => {
    if (error instanceof Error && DYNAMIC_IMPORT_ERROR_PATTERN.test(error.message)) {
      reloadForFreshCode('a route chunk could not be imported');
    }
  });
};
